import React from 'react'

import { Box } from '@chakra-ui/layout'
import {
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerOverlay,
} from '@chakra-ui/modal'
import { useBreakpointValue } from '@chakra-ui/media-query'

import { SidebarDrawerContext } from '../../context/SidebarDrawerContext'

import { SidebarContent } from './Content'

export function Sidebar() {
  const { isOpen, onClose } = React.useContext(SidebarDrawerContext)

  const isDrawerSidebar = useBreakpointValue({
    base: true,
    notebook: false,
  })

  if (isDrawerSidebar) {
    return (
      <Drawer isOpen={isOpen} onClose={onClose} placement="left">
        <DrawerOverlay>
          <DrawerContent background="parkoff.orange.300">
            <DrawerCloseButton color="whiteAlpha.700" marginTop="1.5rem" />
            <DrawerBody>
              <SidebarContent />
            </DrawerBody>
          </DrawerContent>
        </DrawerOverlay>
      </Drawer>
    )
  }

  return (
    <Box as="aside">
      <SidebarContent />
    </Box>
  )
}
